import { useState } from 'react'
import { Check, Copy } from 'lucide-react'

import { Label } from '@/components/ui/label'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'

const CopyToClipboardInput = ({ label, onChange, className, ...props }) => {
  const [codeCopied, setCodeCopied] = useState(false)

  const copyToClipboard = () => {
    navigator.clipboard.writeText(props.value)
  }

  return (
    <div className={className}>
      <Label htmlFor={`${label}-copy-input`}>{label}</Label>
      <div className='relative flex items-center'>
        <Input
          id={`${label}-copy-input`}
          type='text'
          onChange={onChange}
          disabled
          className='pr-10 bg-muted disabled:opacity-100'
          {...props}
        />
        <Button
          aria-label='Copy to clipboard'
          type='button'
          variant='ghost'
          size='icon'
          className='absolute right-1 h-7 w-7'
          onClick={() => {
            copyToClipboard()
            setCodeCopied(true)
            setTimeout(() => setCodeCopied(false), 1000)
          }}
        >
          <Choose>
            <When condition={codeCopied}>
              <Check className='h-4 w-4' />
            </When>
            <Otherwise>
              <Copy className='h-4 w-4' />
            </Otherwise>
          </Choose>
        </Button>
      </div>
    </div>
  )
}

export default CopyToClipboardInput
